import Immutable from 'immutable';
import { SET_CURRENT_VIDEO_POSITION } from '../actions/videoPlayer';

const VIDEO_PLAYER = 'videoPlayer';
const CURRENT_VIDEO_POSITION = 'currentVideoPosition';

const initialState = Immutable.Map({
    isActive: false,
});

export default function videoPlayer(state = initialState, action) {
    switch (action.type) {
        case SET_CURRENT_VIDEO_POSITION:
            if (action.payload.position) {
                return state.setIn([action.payload.id, CURRENT_VIDEO_POSITION], action.payload.position);
            }

            return state.deleteIn([action.payload.id, CURRENT_VIDEO_POSITION]);
        default:
            return state;
    }
}

export const currentVideoPositionSelector = (state, id) => {
    return state.getIn([VIDEO_PLAYER, id, CURRENT_VIDEO_POSITION], 0);
};
